<mat-toolbar color="primary">
    <button mat-icon-button (click)="sidenav.toggle()" matTooltip="Menu">
        <mat-icon style="color: white;">menu</mat-icon>
    </button>
    <a routerLink="/home" class="homeLink desktop"><img class="logo-img" src="./assets/logo-Amrize.svg" /></a>
    <a routerLink="/home" class="homeLink mobile"><img class="logo-img" src="./assets/logo-Amrize.svg" /></a>
    <span class="toolbar-spacer"></span>
    <span class="header-title">Shared Drive App</span>
    <span class="toolbar-spacer"></span>
    <button [matMenuTriggerFor]="menu">
        <span>
            <img class="profile-img" referrerpolicy="no-referrer" src={{user.photoUrl}}>
        </span>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item>
            <span class="profile-email" [matTooltip]="userEmailId">{{ userEmailId }}</span>
        </button>
        <button mat-menu-item (click)="logOut()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
        </button>
    </mat-menu>
</mat-toolbar>